import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

/* Floating back-to-top button on every page; on mobile it floats above the
   fixed bottom navigation bar. */
const BackToTop = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTop = () => {
    if (window.__lenis) window.__lenis.scrollTo(0);
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      onClick={goTop}
      aria-label="Back to top"
      data-testid="back-to-top"
      className={`fixed bottom-[84px] right-4 z-40 flex h-11 w-11 items-center justify-center rounded-full border border-white/15 bg-void/90 text-white shadow-lg backdrop-blur-md transition-all duration-300 hover:border-cyan-300/60 hover:text-cyan-300 lg:bottom-6 lg:right-6 ${
        show ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-3 opacity-0"
      }`}
    >
      <ArrowUp className="h-5 w-5" />
    </button>
  );
};

export default BackToTop;
